import modelmain from "./193_MainSeat.glb";
import ribs from "./193_Ribs.glb";
import logomain from "./193_MainLogo.glb";
import logohexa from "./193_HexaLogo.glb";
// import logoleft from "./193 LogoLeft.glb";
// import logoright from "./193 LogoRight.glb";
// import raceNum from "./193number.glb";
import logoleft from "./193_OldLogoLeft.glb";
import logoright from "./193_OldLogoRight.glb";
import number from "./193_Number.glb";
import { degsToRads } from "../../../utilities";

// This is the main ATV seat Model (AKA Raptor 700)
// Link to test
// /?type=atv&subtype=ribbed&test=yes

const modelParts = {
  main: modelmain,
  ribs: ribs,
  logoMain: logomain,
  logoHexa: logohexa,
  logoLeft: logoleft,
  logoRight: logoright,
  number: number,
  //   logoLeft: logoleft,
  //   logoRight: logoright,
  //   raceNum: raceNum,
};

const numberCoords = {
  modelPosition: [0, 0.1436, -0.2893],
  modelRotation: [0, 0, 0],
  textPosition: [-0.04, -0.08, 0],
  textRotation: [-0.9, 0, 0],
  textScale: 0.44,
  decalSize: 0.1,
  letterSpacing: 0.03,
  aspectRatio: [3, 2],
};

export { modelParts, numberCoords };
